import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { initializeApp } from './plugins/firebase'

import FMap from '@/components/common/FMap.vue'
import FBtn from '@/components/common/FBtn.vue'
import FDialog from '@/components/common/FDialog.vue'
import FForm from '@/components/common/FForm.vue'
import FHeader from '@/components/common/FHeader.vue'
import FIcon from '@/components/common/FIcon.vue'
import './registerServiceWorker'

Vue.config.productionTip = false

// Custom components
Vue.component('f-map', FMap)
Vue.component('f-dialog', FDialog)
Vue.component('f-btn', FBtn)
Vue.component('f-form', FForm)
Vue.component('f-header', FHeader)
Vue.component('f-icon', FIcon)
Vue.directive('line-clamp')

initializeApp()

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
